import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Mousewheel } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/mousewheel";

const projects = [
  {
    title: "Smart Warehouse",
    category: "Logistics",
    image: "/assets/img/project_img03.jpg",
    link: "/services",
  },
  {
    title: "Order Fulfillment",
    category: "Logistics",
    image: "/assets/img/medium-shot-smiley-man-warehouse.jpg",
    link: "/services",
  },
  {
    title: "Customs Clearance",
    category: "Logistics",
    image: "/assets/img/managers-visiting-storage-center-discussing-about-distribution-goals-year.jpg",
    link: "/services",
  },
  {
    title: "Inventory Management",
    category: "Logistics",
    image: "/assets/img/forklift-driver-loading-pallet-shipment-goods-into-truck.jpg",
    link: "/services",
  },
];

export default function ProjectSlider() {
  return (
    <div className="container-fluid p-0 fix">
      <div className="project__item-wrap">
      <Swiper
  modules={[Pagination, Mousewheel]}
  spaceBetween={24}
  slidesPerView={3}
  centeredSlides={true}
  initialSlide={1}

  pagination={{
    el: ".project__nav",
    clickable: true,
    bulletClass: "swiper-pagination-bullet",
    bulletActiveClass: "swiper-pagination-bullet-active",
  }}
  mousewheel={{ forceToAxis: true }}
  wrapperClass="swiper-wrapper"
  className="swiper project-active"
  breakpoints={{
    0: {
      slidesPerView: 1,
      centeredSlides: false,
    },
    768: {
      slidesPerView: 2,
      centeredSlides: false,
    },
    1024: {
      slidesPerView: 3,
      centeredSlides: true,
    },
  }}
>


          {projects.map((project, index) => (
            <SwiperSlide key={index} className="swiper-slide">
              <div className="project__item">
                <div className="project__thumb">
                  <a href={project.link}>
                    <img src={project.image} alt="img" />
                  </a>
                </div>
                <div className="project__content">
                  <div className="content">
                    <h2 className="title">
                      <a href={project.link}>{project.title}</a>
                    </h2>
                    <span>{project.category}</span>
                  </div>
                  <div className="right-arrow">
                    <a href={project.link}>
                      <svg
                        width={13}
                        height={13}
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="injectable"
                      >
                        <path
                          d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                          stroke="currentcolor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* Custom Pagination Dots (aynı class yapısı) */}
        <div className="project__nav swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal"></div>
      </div>
    </div>
  );
}
